<template>
  <div class="image-header-page">
    <image-header v-bind="imageHeaderProps" :style="imageHeaderStyles">
      <template v-slot:header>
        <slot v-if="hasHeaderSlot" name="header"/>
        <div v-else class="image-header-page-header ri-small-display" :style="headerStyles">
          <div class="image-header-page-header-text">{{ imageHeaderProps.title }}</div>
        </div>
      </template>
      <template v-slot:overlayContent>
        <slot name="overlayContent"/>
      </template>
    </image-header>
    <slot class="flex-1"/>
  </div>
</template>

<script>
import ImageHeader, { ImageHeaderProps } from '../components/ImageHeader.vue';
import Colors from '../scss/riseup-js-colors.module.scss';

export default {
  name: 'ImageHeaderPage',
  components: {
    ImageHeader,
  },
  props: {
    imageHeaderProps: ImageHeaderProps,
    stickyHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headerStyles() {
      return {
        color: this.imageHeaderProps.textColor ?? Colors.riseupBlack,
      };
    },
    imageHeaderStyles() {
      return this.stickyHeader ? {
        position: 'sticky',
        top: 0,
      } : undefined;
    },
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/spacings";

.image-header-page {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  width: 100%;
  .image-header-page-header {
    display: flex;
    flex: 1;
    height: 100%;
    width: 100%;
    font-family: SimplerProAlte, sans-serif;
    font-weight: 900;
    text-align: right;
    box-sizing: border-box;
    padding-bottom: $ri-spacing-m;
    .image-header-page-header-text {
      text-align: right;
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      max-width: 70%;
      white-space: pre-wrap;
    }
  }
}

</style>
